import React, { useMemo } from 'react';
import type { FaturaPainel } from '../types';
import { calcularTopDevedores } from '../../../../src/lib/financeiro/definicoesKpi';

interface Props {
  dados: FaturaPainel[]; // conjunto filtrado — o componente extrai só os Vencido
}

const fmtBRL = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 });

const TopDevedoresTable: React.FC<Props> = ({ dados }) => {
  const top10 = useMemo(() => calcularTopDevedores(dados, 10), [dados]);

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
      <h3 className="text-sm font-bold text-gray-800 dark:text-white px-4 pt-4 pb-2">Top 10 Clientes Inadimplentes</h3>
      {top10.length === 0 ? (
        <p className="text-sm text-gray-400 px-4 pb-4">Nenhum cliente inadimplente no filtro atual.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead className="bg-gray-50 dark:bg-gray-900/50 text-gray-500 dark:text-gray-400 text-xs font-medium border-y border-gray-100 dark:border-gray-700">
              <tr>
                <th className="px-4 py-2">Cliente</th>
                <th className="px-4 py-2 text-right">Boletos</th>
                <th className="px-4 py-2 text-right">Valor vencido</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50 dark:divide-gray-700/50">
              {top10.map((d, i) => (
                <tr key={d.cliente + i}>
                  <td className="px-4 py-2.5 font-medium text-gray-800 dark:text-gray-200">{d.cliente}</td>
                  <td className="px-4 py-2.5 text-right text-gray-500 dark:text-gray-400">{d.qtdeBoletos}</td>
                  <td className="px-4 py-2.5 text-right font-semibold text-red-600 dark:text-red-400">{fmtBRL(d.valorVencido)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TopDevedoresTable;
